/*
 * @Author: cc
 * @Date: 2020-02-12 21:52:34
 * @LastEditTime: 2021-10-28 15:40:19
 * @LastEditors: tanyaohua
 * @FilePath: \xjmediacloud\app\editingCenter\trill\pending\pending.js
 * @Description: 抖音渠道待审
 */

'use strict';
angular.module('editTrillPendingModule', ['editTrillPendingRouterModule']).controller('EditTrillPendingCtrl', [
    '$scope',
    '$state',
    '$controller',
    'trillConst',
    'editingMediatype',
    'initTrillEditerBtnService',
    function(
        $scope,
        $state,
        $controller,
        trillConst,
        editingMediatype,
        initTrillEditerBtnService,
    ) {
        initStatus();

        /**
         * [initStatus description] 初始化状态
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.trenchStatus = {
                // mediaType: editingMediatype.trill, // 后端需要的mediaType
                // eslint-disable-next-line camelcase
                status_model: 1, // 后台用来区分待编、待审、已签发
                // accountKey: 'douYinAccountId', // 需要区分一下不同渠道的账号ID
            };
            $scope.trenchData = {
                trenchConst: trillConst, // 渠道需要的常量
            };
            $scope.trenchParams = {
                serviceid: 'mlf_douyin',
                methodName: 'queryToAudit',
                // douYinAccountId: $state.params.account,
                SelectFields: 'ChannelId ACCOUNTID,DocType,CrUser,Title,cover_tsp,errormsg,original,POI_NAME,POI_ID',
            };
            $scope.trenchRightsParams = {
                methodname: 'queryOperKeyOfDouYin',
                Classify: 'douyin.daishen',
                douYinAccountId: $state.params.account,
            };
            $scope.distributionMethodName = 'douyinDaiShenDistribute'; // 多元分发接口名
            $controller('EditShortVideoListCtrl', {$scope: $scope}); // 控制器继承
        }

        /**
         * [trillEditor description]抖音稿件编辑
         * @param   {[type]}  item  [item description]稿件对象
         * @return  {[type]}        [return description]
         */
        $scope.routerToDraftPage = function(item) {
            initTrillEditerBtnService.trillEditor($state.params.account, item.DOUYINARTICLEID, $scope.trenchStatus.status_model);
        };

    },
]);
